import { render } from "./index.vue?vue&type=template&id=131a62f1&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=131a62f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-131a62f1"

export default script